"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Box = require("../../components/Box/Box");

var _SalesCallout = _interopRequireDefault(require("../../components/SalesCallout/SalesCallout"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var SalesCalloutGroomsFree =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SalesCalloutGroomsFree, _PureComponent);

  function SalesCalloutGroomsFree() {
    _classCallCheck(this, SalesCalloutGroomsFree);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesCalloutGroomsFree).apply(this, arguments));
  }

  _createClass(SalesCalloutGroomsFree, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.default.Fragment, null, this.props.theme.brand === 'menguin' ? _react.default.createElement(_SalesCallout.default, {
        ctaPageName: this.props.ctaPageName,
        calloutId: "sales_callout_grooms_free",
        headline: "Grooms rent\xA0free.",
        body: _react.default.createElement(_react.default.Fragment, null, "With 5 members or more in your wedding party, the groom qualifies for a free suit or\xA0tuxedo."),
        ctaTitle: "See Offer",
        ctaUrl: "/how-it-works/free-groom-rental",
        image: "https://gentux.imgix.net/1560435622_menguin-sales-callout-grooms-free.jpg",
        imageAlt: "Gray bow ties with one blue bow tie laying in a grid."
      }) : _react.default.createElement(_SalesCallout.default, {
        ctaPageName: this.props.ctaPageName,
        calloutId: "sales_callout_grooms_free",
        headline: "Free For Grooms",
        body: _react.default.createElement(_react.default.Fragment, null, "With 5 paid members your suit or tux rental is free.", _react.default.createElement(_Box.Box, {
          as: "span",
          mb: 2
        }), "With 7 paid members you can keep your suit or tux, for free."),
        ctaTitle: "See Offer",
        ctaUrl: "/groomsfree",
        image: "https://gentux.imgix.net/1552481737_1539107967_181009-135919-suits-rack-compressed.png?fit=crop&crop=focalpoint&fp-y=1&w=244&h=160",
        imageMobile: "https://gentux.imgix.net/1552481737_1539107967_181009-135919-suits-rack-compressed.png?fit=crop&crop=focalpoint&fp-y=1&w=244&h=135",
        imageAlt: "Black suit and white shirt on a clothes rack."
      }));
    }
  }]);

  return SalesCalloutGroomsFree;
}(_react.PureComponent);

var _default = (0, _styledComponents.withTheme)(SalesCalloutGroomsFree);

exports.default = _default;